export default {
  workorderBookingsInFlight: state => state.workorderBookingsInFlight,
};
